var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "variant-filter-wrapper" },
    [
      _c(
        "div",
        { staticClass: "filter-actions d-flex align-items-center mb-1" },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              on: { click: _setup.toggleFilters },
            },
            [_vm._v("Toggle Filters")]
          ),
          _vm._v(" "),
          _setup.filtersVisible
            ? [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success ml-3",
                    on: { click: _setup.addFilter },
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v("\n                Add Filter\n            "),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info mx-2",
                    attrs: { disabled: _setup.isSearchDisabled },
                    on: { click: _setup.search },
                  },
                  [
                    _c("i", { staticClass: "fa fa-search" }),
                    _vm._v("\n                Search\n            "),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-danger",
                    attrs: {
                      disabled:
                        !_setup.addedFilters.length || _vm.disableActions,
                    },
                    on: { click: _setup.clearFilter },
                  },
                  [
                    _c("i", { staticClass: "fa fa-trash" }),
                    _vm._v("\n                Clear Filters\n            "),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        {
          attrs: { id: "variantFilters" },
          model: {
            value: _setup.filtersVisible,
            callback: function ($$v) {
              _setup.filtersVisible = $$v
            },
            expression: "filtersVisible",
          },
        },
        [
          _c(
            "div",
            { staticClass: "card card-body py-2" },
            [
              _setup.addedFilters.length
                ? _vm._l(_setup.addedFilters, function (filter, idx) {
                    return _c(
                      "div",
                      {
                        key: `filter-${idx}`,
                        staticClass: "d-flex align-items-start my-1",
                      },
                      [
                        _c(_setup.vSelect, {
                          staticClass: "w-50",
                          attrs: {
                            label: "name",
                            placeholder: "Select filter type",
                            options: _vm.filters,
                          },
                          on: {
                            "option:selected": function ($event) {
                              return _setup.onFilterTypeDeselected(filter)
                            },
                          },
                          model: {
                            value: filter.selectedFilter,
                            callback: function ($$v) {
                              _vm.$set(filter, "selectedFilter", $$v)
                            },
                            expression: "filter.selectedFilter",
                          },
                        }),
                        _vm._v(" "),
                        filter.selectedFilter
                          ? _c(_setup.vSelect, {
                              staticClass: "ml-3 w-50",
                              attrs: {
                                multiple: _vm.allowMultipleSelect,
                                label: "name",
                                placeholder: "Select values",
                                options: filter.selectedFilter.values,
                                reduce: (option) => option.value,
                                "close-on-select": false,
                              },
                              model: {
                                value: filter.selectedValues,
                                callback: function ($$v) {
                                  _vm.$set(filter, "selectedValues", $$v)
                                },
                                expression: "filter.selectedValues",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  })
                : _c("div", { staticClass: "text-center" }, [
                    _vm._v("No Filters"),
                  ]),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }